import * as keys from "../constants/keys"
import * as servicebus from "../helpers/serviceBus"
import * as cookieHelper from "../helpers/cookie"
import * as cookieNames from "../booking/constants/Cookies"
import axios from "axios"

export const pageView = async (pageData, profile) => {
  const data = {
    pageData,
    profile,
  }
  await servicebus.sendMessage("pageView", data)
}

export const trackAbEvent = () => {
  let abEvent = cookieHelper.getCookie(cookieNames.GTM_AB_EVENT)
  if (abEvent) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(abEvent)
    cookieHelper.removeCookie(cookieNames.GTM_AB_EVENT)
  }
}

export const setSessionStorageClickProductAndTrack = async (product, listname, position) => {
  if (product === null) return

  const clickedProducts =
    window.sessionStorage.getItem(keys.SESSION_STORAGE_CLICK_PRODUCTS) &&
    JSON.parse(window.sessionStorage.getItem(keys.SESSION_STORAGE_CLICK_PRODUCTS))
  let newClickedProducts = []
  if (clickedProducts && clickedProducts.length > 0) {
    let exists = false
    newClickedProducts = clickedProducts.map((p) => {
      if (p.id === product.ProductVariantId) {
        exists = true
        p.listname = listname
      }
      return p
    })
    if (!exists) newClickedProducts.push({ id: product.ProductVariantId, listname: listname })
  } else {
    newClickedProducts = [{ id: product.ProductVariantId, listname: listname }]
  }
  await trackProductClick(product, listname, position)
  sessionStorage.setItem(keys.SESSION_STORAGE_CLICK_PRODUCTS, JSON.stringify(newClickedProducts))
}

export const getListNameByIdFromSessionStorage = (id) => {
  const clickedProducts =
    window.sessionStorage.getItem(keys.SESSION_STORAGE_CLICK_PRODUCTS) &&
    JSON.parse(window.sessionStorage.getItem(keys.SESSION_STORAGE_CLICK_PRODUCTS))
  if (clickedProducts && clickedProducts.length > 0) {
    const cProduct = clickedProducts.find((p) => p.id === id)
    if (cProduct) return cProduct.listname
  }
  return "product detail"
}

export const addToCart = async (product, listname) => {
  if (product === null) return
  const eventLabel = "addToCart"
  const data = {
    productList: [listname],
    productIds: [product.ProductId],
    productPrices: [parseFloat(product.CurrentDKKPrice / 100).toFixed(2)],
    productCats: [product.WebDefaultCategoryName],
    productVariants: [product.ProductVariantId],
    productBrands: [product.Brand],
    ecommerce: {
      currencyCode: "DKK",
      add: {
        actionField: { list: listname },
        products: [
          {
            id: product.ProductId,
            name: product.PureTitle || product.Title,
            price: parseFloat(product.CurrentDKKPrice / 100).toFixed(2),
            category: product.WebDefaultCategoryName,
            brand: product.Brand,
            variant: product.ProductVariantId,
            quantity: 1,
          },
        ],
      },
    },
    event: eventLabel,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const addToCartFailed = (product, eventLabel) => {
  if (product === null) return

  const data = {
    event: "track-event",
    eventCategory: "ecommerce", //statisk
    eventAction: "add to cart failed", //statisk
    eventLabel: eventLabel, //statisk
    eventValue: product.quantity,
    eventNoninteraction: true, //statisk
    pageBusinessunit: "taxfree", //statisk
    ecommerceTaxfreeProductId: product.id,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const removeFromCart = async (product, listname) => {
  if (product === null) return
  const eventLabel = "removeFromCart"
  const data = {
    productList: [listname],
    productIds: [product.ProductId],
    productPrices: [parseFloat(product.CurrentDKKPrice / 100).toFixed(2)],
    productCats: [product.WebDefaultCategoryName],
    productVariants: [product.ProductVariantId],
    productBrands: [product.Brand],
    ecommerce: {
      currencyCode: "DKK",
      add: {
        actionField: { list: listname },
        products: [
          {
            id: product.ProductId,
            name: product.PureTitle || product.Title,
            price: parseFloat(product.CurrentDKKPrice / 100).toFixed(2),
            category: product.WebDefaultCategoryName,
            brand: product.Brand,
            variant: product.ProductVariantId,
            quantity: 1,
          },
        ],
      },
    },
    event: eventLabel,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const productDetailView = async (product) => {
  if (product === null) return
  const eventLabel = "productdetail"
  const data = {
    ecommerce: {
      currencyCode: "DKK",
      detail: {
        actionField: { list: "product detail" }, // statisk
        products: [
          {
            id: product.ProductId,
            name: product.PureTitle || product.Title,
            price: parseFloat(product.CurrentDKKPrice / 100).toFixed(2),
            category: product.WebDefaultCategoryName,
            brand: product.Brand,
            variant: product.ProductVariantId,
          },
        ],
      },
    },
    event: eventLabel,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)

  await servicebus.sendMessage(eventLabel, data)
}

export const impressions = async (products, listname, event) => {
  const data = {
    ecommerce: {
      currencyCode: "DKK",
      impressions: products.map((product, index) => {
        return {
          id: product.ProductId || product.productId,
          name: product.PureTitle || product.Title || product.title,
          price: product.CurrentDKKPrice
            ? parseFloat(product.CurrentDKKPrice / 100).toFixed(2)
            : product.DecimalPrice
              ? parseFloat(product.DecimalPrice).toFixed(2)
              : parseFloat(product.price).toFixed(2),
          category: product.WebDefaultCategoryName || product.trumpet || "",
          brand: product.Brand || product.brand,
          variant: product.ProductVariantId || product.key,
          list: listname,
          position: index + 1,
        }
      }),
      event: event,
    },
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)

  await servicebus.sendMessage("impressions", data)
}

export const highlightedContentImpressions = async (promotions) => {
  const data = {
    ecommerce: {
      promoView: {
        promotions: promotions.map((promo) => {
          return {
            id: promo.id,
            name: promo.name,
            creative: promo.creative,
            position: promo.position,
          }
        }),
      },
    },
    event: "eec.promo.impression",
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const highlightedContentClicks = async (promotions) => {
  const data = {
    ecommerce: {
      promoClick: {
        promotions: promotions.map((promo) => {
          return {
            id: promo.id,
            name: promo.name,
            creative: promo.creative,
            position: promo.position,
          }
        }),
      },
    },
    event: "eec.promo.click",
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const trackFilterClick = async (eventLabel, eventAction) => {
  const data = {
    event: "track-event",
    eventCategory: "ecommerce",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

const trackProductClick = async (product, listname, position) => {
  if (product === null) return
  const eventLabel = "productClick"
  const data = {
    ecommerce: {
      currencyCode: "DKK",
      click: {
        actionField: { list: listname },
        products: [
          {
            id: product.ProductId,
            name: product.PureTitle || product.Title,
            price: product.DecimalPrice ? parseFloat(product.DecimalPrice / 100).toFixed(2) : parseFloat(product.CurrentDKKPrice / 100).toFixed(2),
            category: product.WebDefaultCategoryName,
            brand: product.Brand,
            variant: product.ProductVariantId,
            position: position, //Position i vare listen. ie. produkt nr. 1, nr. 2, nr. 3 eller lign.
          },
        ],
      },
    },
    event: eventLabel,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)

  await servicebus.sendMessage(eventLabel, data)
  if (product.richRelevanceClickUrl) {
    axios.get(product.richRelevanceClickUrl)
  }
}

export const trackProfileNewsletterSignup = async (eventAction, eventLabel) => {
  const userId = cookieHelper.getUserId()
  const data = {
    eventCategory: "permission",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    event: "track-event",
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (userId) data.userId = userId
  window.dataLayer.push(data)
}

export const trackCTALoginButtonClick = async (eventLabel) => {
  const data = {
    eventCategory: "cph profile",
    eventAction: "cta click - login",
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    event: "track-event",
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const trackSiteSearch = async (eventCategory, eventAction, eventLabel, eventValue) => {
  const data = {
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: eventValue,
    eventNoninteraction: true,
    event: "track-event",
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

//this is to track the search query and result count 500ms after last keypress in typeahead
var timeout
export const handleSearchTrackingTimeout = (track, eventCategory, eventAction, eventLabel, eventValue) => {
  if (track) {
    if (timeout) {
      clearTimeout(timeout)
      timeout = undefined
    }
    timeout = setTimeout(() => {
      trackSiteSearch(eventCategory, eventAction, eventLabel, eventValue)
    }, 500)
  }
}

export const handleClickTracking = (tracking) => {
  if (tracking) {
    const fn = new Function(tracking)
    fn()
  }
}

export const trackTravelPlanner = async (
  event,
  eventAction,
  eventLabel,
  flightId,
  merchantName = null,
  merchantNumber = null,
  merchantCategories = null,
) => {
  const data = {
    event: event,
    eventCategory: "travel planner",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    travelplannerFlightId: flightId,
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (merchantName) data.storeName = merchantName
  if (merchantNumber) data.storeId = merchantNumber
  if (merchantCategories) data.storeCategory = merchantCategories
  window.dataLayer.push(data)
}

export const trackTravelPlannerInteraction = async (flowName, interaction, obj) => {
  const data = {
    event: "travelplanner_interaction",
    logged_in: cookieHelper.isLoggedIn(),
    flow_name: flowName,
    interaction: interaction,
    ...obj,
  }
  window.dataLayer.push(data)
}

export const trackTravelPlannerParkingSearch = async (event, eventAction, eventLabel, flightId, fromDateTime, toDateTime) => {
  const data = {
    event: event,
    eventCategory: "travel planner",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    travelplannerFlightId: flightId,
    userParkingArrivalDate: fromDateTime,
    userParkingDepartureDate: toDateTime,
    logged_in: cookieHelper.isLoggedIn(),
  }
  window.dataLayer.push(data)
}

export const trackParkingFlightSignup = async (event, eventAction, eventLabel, departureFlight, arrivalFlight) => {
  const data = {
    event: event,
    eventCategory: "parking",
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventValue: 0,
    eventNoninteraction: true,
    logged_in: cookieHelper.isLoggedIn(),
  }
  if (departureFlight) data.userDestinationDepartureFlightId = departureFlight.FlightId
  if (arrivalFlight) data.userDestinationArrivalFlightId = arrivalFlight.FlightId
  window.dataLayer.push(data)
}

export const trackSearchInteraction = (userId, searchterm) => {
  const data = {
    event: "siteSearch",
    siteSearchQuery: searchterm,
  }
  if (userId) data.userId = userId

  window.dataLayer.push(data)
}

export const handleEvalTracking = (tracking) => {
  try {
    eval(tracking)
  } catch (error) {
    console.error("Error in handleClickTracking", error)
  }
}
